import React, { useEffect, useState } from 'react'
import UserMiniProfile from '../components/UserMiniProfile';
import YouTubeVideoPlayer from '../components/YouTubeVideoPlayer';
import { isBrowser } from 'react-device-detect';

export default function Iuiu(props) {
    const [zoomin, setZoomin] = useState("")
    const {filenames, user} = props
    const path = process.env.REACT_APP_STATIC_CDN_ASSETS_IUIU
    const chowcolateBirthday = new Date(`${(new Date().getFullYear()+1).toString()}-09-01T00:00:00`); 
    const mintoBirthday = new Date(`${(new Date().getFullYear()+1).toString()}-07-26T00:00:00`); 
    const [timeLeft, setTimeLeft] = useState(getTimeRemaining(chowcolateBirthday));
    const [timeLeft2, setTimeLeft2] = useState(getTimeRemaining(mintoBirthday));

    function getTimeRemaining(targetDate) {
        const total = targetDate - new Date();
        if (total <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        return {
        days: Math.floor(total / (1000 * 60 * 60 * 24)),
        hours: Math.floor((total / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((total / 1000 / 60) % 60),
        seconds: Math.floor((total / 1000) % 60),
        };
    }

    useEffect(() => {
        const main = document.querySelector('main');
        const elements = document.querySelectorAll(".stickyBookmark");
        const observer = new IntersectionObserver(
            (entries) => {
            entries.forEach((e) => {
                console.log(">>", e.target.textContent, "isIntersecting:", e.isIntersecting, "ratio:", e.intersectionRatio);
                e.target.classList.toggle("stuck", !e.isIntersecting);
            });
            },
            { 
                threshold: [1],
                root: main
            }
        );

        elements.forEach((el) => observer.observe(el));
        const timer = setInterval(() => {
            setTimeLeft(getTimeRemaining(chowcolateBirthday));
            setTimeLeft2(getTimeRemaining(mintoBirthday));
        }, 1000);
        return () => observer.disconnect(); clearInterval(timer);
    }, [zoomin, filenames]);
    return (
        <div style={{overflow: "visible"}}>
            {/* <div className='scrollableDiv full'> */}
                <div className='row center' id="note">
                    <div className='col-0'>
                        <div className='row center'>
                            {user &&  <div><UserMiniProfile user={user[Object.keys(user)[0]]} placebotext={`Art for Chowcolate by Minto aka `}></UserMiniProfile></div>}
                        </div>
                        <div className='row center space'>
                            <h1 className='interactiveText iuiuButton' onClick={()=>window.open("https://docs.google.com/spreadsheets/d/150gMGUrAD13XnV-JPB4eFMETQOqGrv3Z_XQiSYOvYm4/edit?gid=302182646#gid=302182646", "_blank")}>
                                View our file
                            </h1>
                            <div className='countdownCard'>
                                <div className='row space'>
                                    <div className='row'>
                                        Countdown til our next birthdays:
                                    </div>
                                    <div className='row space calendarRow1'>
                                        <div className='row left'>
                                            Us
                                        </div>
                                        <div className='row left'>
                                            d
                                        </div>
                                        <div className='row left'>
                                            h
                                        </div>
                                        <div className='row left'>
                                            m
                                        </div>
                                        <div className='row left'>
                                            s
                                        </div>
                                    </div>
                                    <div className='row space calendarRow2'>
                                        <div className='row left'>🍫</div> 
                                        <div className='row left'>
                                            {timeLeft.days}
                                        </div>
                                        <div className='row left'>
                                            {timeLeft.hours}
                                        </div>
                                        <div className='row left'>
                                            {timeLeft.minutes}
                                        </div>
                                        <div className='row left'>
                                            {timeLeft.seconds}
                                        </div>
                                    </div>
                                    <div className='row space calendarRow3'>
                                        <div className='row left'>🌿</div> 
                                        <div className='row left'>
                                            {timeLeft2.days}
                                        </div>
                                        <div className='row left'>
                                            {timeLeft2.hours}
                                        </div>
                                        <div className='row left'>
                                            {timeLeft2.minutes}
                                        </div>
                                        <div className='row left'>
                                            {timeLeft2.seconds}
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
                {
                    filenames && filenames.length > 0 && filenames.map(filename => 
                        (<div id={filename.albumTitle} className='col-0 tabItem album'>
                                <h1 className='albumTitle iuiu stickyBookmark' title={filename.albumTitle}>
                                    {filename.albumTitle}
                                </h1>
                                {filename.description.split("\n").map((d)=>
                                <h2>
                                    {d}
                                </h2>)}
                                {filename.images.map((f)=><div className='row center interactiveText' onClick={()=>setZoomin(f)} style={{paddingBottom: "1rem"}}>
                                <img className='showcase' src={`${path}/${f}`} alt={f}/>
                            </div>)}
                                {filename?.videos && filename?.videos.map((f)=>f.includes("youtube")&&<div className='row center interactiveText' onClick={()=>setZoomin(f)} style={{paddingBottom: "1rem"}}>
                                <div className='col-0'>
                                    <YouTubeVideoPlayer videoId={f} height="500" width="500" autoplay={true} allowFullScreen={true} loop={true} mute={true}></YouTubeVideoPlayer>
                                </div>  
                                </div>)}
                        </div>
                    ))
                }
                <div className='row center' id="note" style={{paddingBottom: "5rem"}}>
                    <div className='col-0'>
                        <div className='row center'>Took me a bit too long to get these sticky titles to work properly 💀</div>
                    </div>
                   
                </div>
                {zoomin && <div className='viewingImageDiv' onClick={()=>setZoomin("")}><img className='zoomimg' src={`${path}/${zoomin}`}></img> <div className='' style={{backgroundColor: "#000"}}>click again to close</div></div>}
                
            {/* </div> */}
            {isBrowser && <div className='titleCardContainer birthday'><div className=''>{`Happy Birthday Babi`}</div></div>}
            {isBrowser && <div className='confetti left'><div className='titleCard'>{`🎉`}</div></div>}
            {isBrowser && <div className='confetti right'><div className='titleCard'>{`🎇`}</div></div>}
        </div>
    ) 
}
